<script>
    import {workouts} from './calendarWorkouts.js'
    import {getFirstDayOfTheWeek, getLastDayOfTheWeek, searchDateFromArray, plusDate, formatDate} from './utils.js'
    import MobileDay from "./EventCalendarMobileDay.svelte";

    let now = new Date();
    const currentYear = now.getFullYear();
    const currentMonth = now.getMonth(); // 0-11

    // Määrittämällä käsin kuukauden, voidaan testata seuraavan kuukauden toimivuutta.
    //const currentMonth = 0; // 0 = Tammikuu, 11 = Joulukuu
    //const currentDay = 5;
    //now = new Date(currentYear, currentMonth, currentDay);
    const firstDayOfCurrentMonth = new Date(currentYear, currentMonth, 1).getDate();
    const firstDayWeekDayNro = new Date(currentYear, currentMonth, 1).getDay();
    const lastDayOfCurrentMonth = new Date(currentYear, currentMonth + 1, 0).getDate();
    const firstDayOfTheCurrentWeek = getFirstDayOfTheWeek(new Date());

    //console.log("firstDayWeekDayNro:", firstDayWeekDayNro);
    //console.log("viikon eka päivä ", firstDayOfTheCurrentWeek);
    //console.log("viikon vika päivä", getLastDayOfTheWeek(new Date()));

    function getWeekDayNro(year, month, dayNro) {
        let d = new Date(year, month, dayNro)
        let nro = d.getDay();
        //console.log("getWeekDayNro", d, nro);
        return nro;
    }

    let boxes = [];
    let dd = 1;
    let box = 1;

    function getBoxWeekdayNumber(bn) {
        let value = 0;
        switch (bn) {
            case 1:
                value = 1;
                break;
            case 2:
                value = 2;
                break;
            case 3:
                value = 3;
                break;
            case 4:
                value = 4;
                break;
            case 5:
                value = 5;
                break;
            case 6:
                value = 6;
                break;
            case 7:
                value = 0;
                break;
            default:
                value = 0;
        }
        return value;
    }

    // Create array which is used to draw the calendar
    for (var i = 1; i < 7; i++) {
        for (var j = 1; j <= 7; j++) {
            if (getWeekDayNro(currentYear, currentMonth, dd) == getBoxWeekdayNumber(j) &&
                dd <= lastDayOfCurrentMonth) {
                boxes.push({
                    box: box,
                    date: new Date(currentYear, currentMonth, dd),
                    valid: true
                });
                dd++;
                box++;
            } else {
                boxes.push({
                    box: box,
                    valid: false
                });
                box++;
            }
        }
    }

    // Ikkunan leveys 
    /* tämä ei toimi jos ikkunan kokoa skaalataan lennosta, siksi kommentteihin! -> siirretään määrittelemään leveys css:ssä
    let windowWidth = window.innerWidth; // Default -
    let usableWidth = windowWidth - 100 // vähennetään päddingit laidasta
    if(usableWidth > 1133) {
        usableWidth = 1133;
    }  

    let cellWidth = (usableWidth / 7)+"px"; // Korjattu yhden päiväkentän leveys
    */
    //console.log ("windowWidth", windowWidth, "usableWidth", usableWidth, "cellWidth", cellWidth);

    // Katotaan onko sisäinen div
    function boxCountStyle(j) {
        let classText = ""
        // Ylin rivi
        if(j >= 0 && j <= 6 ) classText = "topRow";

        if(j == 7) classText = "outterBox";
        if (j > 7 && j < 14) classText = "innerBox";

        if(j == 14) classText = "outterBox";
        if (j > 14 && j < 21) classText = "innerBox";

        if(j == 21) classText = "outterBox";
        if (j > 21 && j < 28) classText = "innerBox";

        if(j == 28) classText = "outterBox";
        if (j > 28 && j < 35) classText = "innerBox";

        if(j == 35) classText = "outterBox";
        if (j > 35 && j < 42) classText = "innerBox";

        if(j == 42) classText = "outterBox";
        if (j > 42 && j < 49) classText = "innerBox";

        return classText;
    }

    // Kaivellaan vähä vanhanaikaisesti kuukausinumerosta suomenkielinen kuukauden nimi
    function currentMonthName() {
        let d = now;
        let month = d.getMonth();
        let kuukausi;

        switch (month) {
            case 0: kuukausi = "Tammikuu"; break;
            case 1: kuukausi = "Helmikuu"; break;
            case 2: kuukausi = "Maaliskuu"; break;
            case 3: kuukausi = "Huhtikuu"; break;
            case 4: kuukausi = "Toukokuu"; break;
            case 5: kuukausi = "Kesäkuu"; break;
            case 6: kuukausi = "Heinäkuu"; break;
            case 7: kuukausi = "Elokuu"; break;
            case 8: kuukausi = "Syyskuu"; break;
            case 9: kuukausi = "Lokakuu"; break;
            case 10: kuukausi = "Marraskuu"; break;
            case 11: kuukausi = "Joulukuu"; break;
            default: kuukausi = "Ei löydetty";

        }

        return kuukausi;
    }
</script>

<div class="page">
    <div class="grid-calendar">
        <h1 class="headerText">Treenit</h1>

        <div class="subNaviLinks">
            <a href="/treenit-aukioloajat" class="current">Treenit ja aukioloajat</a>
            <a href="/aloittaminen">Näin aloitat harjoittelun</a>
            <a href="/perheet">Lapset ja perheet salilla</a>
            <a href="/treenisanasto">Treenisanasto</a>
            <a href="/sopimusehdot">Sopimusehdot</a>
        </div>

        <h2>Treenikalenteri</h2>

        <!-- Piilotetaan mobiilinäkymässä -->
        <div class="monthCalendar d-none d-sm-block">
            <h3>{currentMonthName()} {currentYear}</h3>
            <div class="row">
                <div class="col-xs-12">
                    <div class="weekday">MA</div>
                    <div class="weekday">TI</div>
                    <div class="weekday">KE</div>
                    <div class="weekday">TO</div>
                    <div class="weekday">PE</div>
                    <div class="weekday">LA</div>
                    <div class="weekday">SU</div>
                </div>
            </div>
            <div class="row">
                <div class="col-xs-12">
                    {#each boxes as b, j}
                        {#if boxes[j].valid}
                            <div class="daybox singleDay {boxCountStyle(j)}">
                                <span class="dayNro">{formatDate(boxes[j].date, "d")}</span>
                                {#each searchDateFromArray(formatDate(boxes[j].date), workouts) as t}
                                    <div class="workout type-{t.type} col-xs-12">
                                        <span>{t.start} </span>
                                        <span>{t.name} </span>
                                    </div>
                                {/each}
                            </div>
                        {:else}
                            <div class="daybox wrongDay {boxCountStyle(j)}"></div>
                        {/if}
                    {/each}
                </div>
            </div>
        </div>
        <div class="col-xs-12">
            <!-- Määritellään, että nämä näytetään vain mobiilissa -->
            <div class="weekCalendar d-block d-sm-none">
                <!-- Näytetään mobiilinäkymässä kaksi viikkoa. Tässä ensimmäinen -->
                <div class="row">
                    <div class="col-xs-12">
                        <p style="font-weight: bold; padding-left: 16px;">
                            {formatDate(firstDayOfTheCurrentWeek)} - {formatDate(getLastDayOfTheWeek(new Date()))}
                        </p>
                    </div>
                </div>

                {#each Array(7) as _, i}
                    <MobileDay week={Math.floor(i/7)+1} plusDays={i} />
                {/each}
                <!-- Näytetään mobiilinäkymässä kaksi viikkoa. Tässä toinen -->
                <div class="row">
                    <div class="col-xs-12">
                        <p style="font-weight: bold; padding-left: 16px;">
                            {formatDate(plusDate(firstDayOfTheCurrentWeek,6))} - {formatDate(plusDate(getLastDayOfTheWeek(new Date()),6))}
                        </p>
                    </div>
                </div>

                {#each Array(7) as _, i}
                    <MobileDay week={Math.floor((i+7)/7)+1} plusDays={i+7} />
                {/each}
            </div>
        </div>
    </div>
</div>


<style>
    .grid-calendar {
        width: 100%;
        padding-right: 15px;
        padding-left: 15px;
        margin-right: auto;
        margin-left: auto;
        max-width: 1140px;
    }
    .monthCalendar {
        width: 1200px;
    }

    .daybox {
        font-size: 0.875rem;
    }

    .singleDay {
        height: 120px;
        width: 160px;
        float: left;
        background-color: white;
    }

    .wrongDay {
        height: 120px;
        width: 160px;
        float: left;
        background-color: #d2d2d2;
    }

    .weekday {
        height: 40px;
        width: 160px;
        padding: 8px;
        float: left;
        text-align: center;
    }
    .topRow {
        border-top: solid 1px gray;
        border-right: solid 1px gray;
        border-bottom: solid 1px gray;
    }
    .topRow:first-child {
        border-left: solid 1px gray;
    }
    .outterBox {
        border-bottom: solid 1px gray;
        border-left: solid 1px gray;
        border-right: solid 1px gray;
    }
    .innerBox {
        border-bottom: solid 1px gray;
        border-right: solid 1px gray;
    }
    .weekdayMobile {
        height: 40px;
        padding: 8px;
        font-weight: bold;
    }

    /* Inside calendar day box*/
    .dayNro {
        padding: 8px;
    }

    .workout {
        font-weight: bold;
        margin: 8px;
        padding: 4px;
        border-radius: 4px;
    }

    .type-savotta {
        background-color: #a7ad94;
    }

    .mobile-type-savotta {
        color: #5b5f51;
    }

    .type-pilates {
        background-color: #93adef;
    }

    .mobile-type-pilates {
        color: #475373;
    }

    .type-kehonhuolto {
        background-color: #c1cdec;
    }

    .mobile-type-kehonhuolto {
        color: #606675;
    }

    .type-kaski {
        background-color: #c9d0b2;
    }

    .mobile-type-kaski {
        color: #66695c;
    }

    .type-painonnosto {
        background-color: #ece5c7;
    }

    .mobile-type-painonnosto {
        color: #5a574b;
    }
    .type-perjantailiiga {
        background-color: #eae1ba;
    }

    .mobile-type-perjantailiiga {
        color: #5a574b;
    }
    .type-pikkujoulut {
        background-color: #D6001C;
        color: black;
    }

    .mobile-type-pikkujoulut {
        color: #D6001C;
    }
    .type-sauvakavely {
        background-color: #77BFC7;
        color: black;
    }
    .mobile-type-sauvakavely {
        background-color: #77BFC7;
    }


</style>
